export default [
    {
        path: "/:catalog/product/:productId",
        props: true,
        name: "product-detail",
        component: () => import("./components/product-detail.vue"),
        meta: {
            title: "OneBuy",
        }
    },
];
